import {
    Link as UiLink,
    styled,
    styledForMobile,
    SIDEBAR_SPACING,
    SIDEBAR_SPACING_MOBILE,
    Typography,
} from "@l2r-front/l2r-ui"

import { DocumentDetailsRoadInfo } from "../../components/DocumentDetailsRoadInfo"

import { DocumentList as L2RDocumentList } from "../DocumentList"

export const Container = styledForMobile("div")(({ isMobile, theme }) => ({
    backgroundColor: theme.palette["common/gray_states/light"].main,
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    overflowY: "auto",
    padding: isMobile ? theme.spacing(0, SIDEBAR_SPACING_MOBILE, 0, SIDEBAR_SPACING_MOBILE) : theme.spacing(5, SIDEBAR_SPACING, 0, SIDEBAR_SPACING),
}))

export const HeaderWrapper = styledForMobile("div")(({ isMobile, theme }) => ({
    backgroundColor: "white",
    padding: isMobile ? theme.spacing(0, SIDEBAR_SPACING_MOBILE, SIDEBAR_SPACING_MOBILE, SIDEBAR_SPACING_MOBILE) : theme.spacing(5, SIDEBAR_SPACING, 8, SIDEBAR_SPACING),
    margin: isMobile ? theme.spacing(0, -SIDEBAR_SPACING_MOBILE, -SIDEBAR_SPACING_MOBILE, -SIDEBAR_SPACING_MOBILE) : theme.spacing(-5, -SIDEBAR_SPACING, 0, -SIDEBAR_SPACING),
}))

export const RoadDetailInfo = styled(DocumentDetailsRoadInfo)(() => ({
    margin: 0,
}))

export const DocumentList = styledForMobile(L2RDocumentList)(({ isMobile, theme }) => ({
    flex: "1 1 auto",
    height: "auto",
    padding: isMobile ? theme.spacing(2 * SIDEBAR_SPACING_MOBILE, 0, SIDEBAR_SPACING_MOBILE, 0) : theme.spacing(SIDEBAR_SPACING, 0, SIDEBAR_SPACING, 0),
}))

export const LinkText = styled(Typography)(() => ({
    textDecoration: "underline",
}))

export const Link = styled(UiLink)(({ theme }) => ({
    color: theme.palette.text.primary,
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
}))

export const PaginationContainer = styledForMobile("div", ["position"])(({ isMobile, position, theme }) => ({
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette["common/gray_states/light"].main,
    position: position,
    bottom: 0,
    paddingTop: theme.spacing(5),
    paddingBottom: isMobile ? theme.spacing(SIDEBAR_SPACING_MOBILE) : theme.spacing(5),
    margin: isMobile ? theme.spacing(0, -SIDEBAR_SPACING_MOBILE, 0, -SIDEBAR_SPACING_MOBILE) : theme.spacing(0, -SIDEBAR_SPACING, 0, -SIDEBAR_SPACING),
}))